import Block from './Block'
import SlideManager from '../util/SlideManager'
import gsap from 'gsap';

export default class ProjectSlider extends Block {
  onEnterCompleted() {
    this.init()
    this.createSlider()
  }

  getElems() {
    this.items = []

    this.wrapper = this.el.querySelector('.b-project-slider__images')
    this.$items = this.el.querySelectorAll('.b-project-slider__image')
    this.$itemsInner = this.el.querySelectorAll('.b-project-slider__image--inner')
    this.pagerPrev = this.el.querySelector('.pager--prev')
    this.pagerNext = this.el.querySelector('.pager--next')

    for (let i = 0; i < this.$items.length; i++) {
      this.items.push({
        wrapper: this.$items[i],
        inner: this.$itemsInner[i],
        image: this.$itemsInner[i].children[0]
      })
    }
  }

  events() {
    this.pagerPrev.addEventListener('click', this.prevSlide.bind(this))
    this.pagerNext.addEventListener('click', this.nextSlide.bind(this))
  }

  init() {
    for (let i = 1; i < this.items.length; i++) {
      gsap.set(this.items[i].wrapper, { xPercent: 100 })
      gsap.set(this.items[i].inner, { xPercent: -100 })
      gsap.set(this.items[i].image, { scale: 1.1 })
    }
  }

  createSlider() {
    this.slider = new SlideManager({
      el: this.wrapper,
      loop: true,
      callback: (event) => {
        this.oldIndex = event.previous
        this.currentIndex = event.new
        this.direction = event.direction

        this.updateSlider(this.items[this.oldIndex], this.items[this.currentIndex]).then(this.slider.done.bind(this.slider))
      }
    })
  }

  updateSlider(old, current) {
    return new Promise((resolve) => {
      const tl = gsap.timeline()

      tl
        .addLabel('start', 0)
        .fromTo(current.wrapper, { xPercent: 100 * this.direction }, {
          xPercent: 0,
          ease: 'expo.out',
          duration: 0.9
        }, 'start')
        .fromTo(current.inner, { xPercent: -100 * this.direction }, {
          xPercent: 0,
          ease: 'expo.out',
          duration: 0.9
        }, 'start')
        .fromTo(current.image, { scale: 1.1 }, {
          scale: 1,
          ease: 'expo.out',
          duration: 0.9
        }, 'start')
        .to(old.wrapper, {
          xPercent: -100 * this.direction,
          ease: 'expo.out',
          duration: 0.9
        }, 'start')
        .to(old.inner, {
          xPercent: 100 * this.direction,
          ease: 'expo.out',
          duration: 0.9
        }, 'start')
        .to(old.image, {
          scale: 1,
          ease: 'expo.out',
          duration: 0.9
        }, 'start')

      resolve()
    })
  }

  prevSlide() {
    this.slider.prev()
  }

  nextSlide() {
    this.slider.next()
  }
}
